/**
 * Podrazumevane vrednosti preferenci i liste opcija u panelu.
 * Kontrastne teme: ključ `key` postaje klasa `ap-theme-{key}` na <html> (osim `default`).
 */

/** Početno stanje i vrednost posle „Ресетуј”. */
export const DEFAULTS = {
  textSize: 1,
  lineSpacing: 1,
  textStyle: 'default',
  contrast: 'default',
  toc: false,
  enhanceInputs: false,
};

/** `family` prazan = podrazumevani font stranice. OpenDyslexic zahteva @font-face u host aplikaciji. */
export const FONT_OPTIONS = [
  { key: 'default', label: 'Подразумевани', family: '' },
  { key: 'comic-sans', label: 'Comic Sans', family: '"Comic Sans MS", "Comic Sans", cursive' },
  { key: 'arial', label: 'Arial', family: 'Arial, Helvetica, sans-serif' },
  { key: 'times', label: 'Times New Roman', family: '"Times New Roman", Times, serif' },
  { key: 'open-dyslexic', label: 'OpenDyslexic', family: 'OpenDyslexic, sans-serif' },
];

/**
 * Kontrastne šeme. `fg`/`bg` na swatch dugmadima (preview); stvarna tema je u CSS var --ap-fg/--ap-bg.
 */
export const CONTRAST_OPTIONS = [
  { key: 'default', label: 'Подразумевано', fg: null, bg: null },
  { key: 'bw', label: 'Црно на белом', fg: '#000', bg: '#fff' },
  { key: 'wb', label: 'Бело на црном', fg: '#fff', bg: '#000' },
  { key: 'by', label: 'Црно на жутом', fg: '#000', bg: '#ff0' },
  { key: 'yb', label: 'Жуто на црном', fg: '#ff0', bg: '#000' },
  { key: 'lgdg', label: 'Светлосиво на тамносивом', fg: '#ccc', bg: '#333' },
  { key: 'gw', label: 'Сиво на белом', fg: '#888', bg: '#fff' },
  { key: 'gd', label: 'Сиво на тамном', fg: '#999', bg: '#222' },
  { key: 'bbr', label: 'Црно на браон', fg: '#000', bg: '#bb9966' },
];
